import { formatBytes, type AudioTrack } from '../../api'
import { formatDuration } from '../visuals/formatDuration'

const formatMimeSubtype = (mimeType: string | null): string | null => {
  if (!mimeType) {
    return null
  }

  const subtype = mimeType.split('/')[1]?.trim().toLowerCase()

  if (!subtype) {
    return mimeType.trim().toLowerCase()
  }

  return subtype.split('+')[0] ?? subtype
}

export const formatAudioMetadata = (track: AudioTrack): string => {
  return getAudioTrackMetadataItems(track)
    .filter((item) => item.key !== 'duration')
    .map((item) => item.value)
    .join(' · ')
}

export type AudioTrackMetadataItem = {
  key: 'format' | 'size' | 'duration'
  label: string
  value: string
}

export const getAudioTrackMetadataItems = (track: AudioTrack): AudioTrackMetadataItem[] => {
  const items: AudioTrackMetadataItem[] = [
    {
      key: 'format',
      label: 'Format',
      value: formatMimeSubtype(track.mime_type) ?? 'unknown format'
    },
    {
      key: 'size',
      label: 'Size',
      value: formatBytes(track.size_bytes)
    }
  ]
  const duration = formatDuration(track.duration_seconds)

  if (duration) {
    items.push({
      key: 'duration',
      label: 'Duration',
      value: duration
    })
  }

  return items
}
